module.exports = __webpack_public_path__ + "static/6305-woodrose-43-cf8db4f1f97f6db8984d34021361d350.jpg";